import { useState, useContext, useEffect } from 'react'
import Modal from 'react-modal'
import axios from 'axios'

import { projectContext, loadingContext, unfolder, useTranslate } from '../lib'
import { urlValue } from '../lib'

import '../styles/selectCodeModal.scss'
import { customModal } from '../styles/customModal'

export default function SelectCodeModal({ isModalOpen, setIsModalOpen, setValue }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [search, setSearch] = useState('')
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [intents, setIntents] = useState([])
  const { t } = useTranslate();
  useEffect(() => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/${selectedProject.id}/intents`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        setIntents(response.data)
        setLoading(false)
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }, [])

  function onSubmit(value) {
    setValue('code', value)
    setSearch('')
    setIsModalOpen({ delete: false, code: false })
  }

  return (
    <Modal isOpen={isModalOpen.code} style={customModal} ariaHideApp={false}>
      <div className="selectCode-modal" style={{zIndex: 500}}>
        <h1>{t('menu.selectCode')}</h1>
        <span
          onClick={() => {
            setIsModalOpen({ delete: false, code: false })
          }}
        >
          X
        </span>
        <input
          onChange={event => {
            setSearch(event.target.value)
          }}
        ></input>
        <div className="intents">
          {intents
            .filter(value => {
              if (search == '') {
                return value
              } else if (value.displayName.toLowerCase().includes(search.toLowerCase())) {
                return value
              }
            })
            .map((data, index) => (
              <button key={index} onClick={() => onSubmit(data.displayName)}>
                <p>{data.displayName}</p>
              </button>
            ))}
        </div>
      </div>
    </Modal>
  )
}
